import { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import toast from 'react-hot-toast'
import { FiPlus, FiEdit2, FiTrash2, FiUpload, FiX, FiLoader } from 'react-icons/fi'

const CURRENCIES = [
  // Paystack Supported Currencies (marked with *)
  { code: 'NGN', symbol: '₦', name: 'Nigerian Naira', paystackSupported: true },
  { code: 'USD', symbol: '$', name: 'US Dollar', paystackSupported: true },
  { code: 'GHS', symbol: '₵', name: 'Ghanaian Cedi', paystackSupported: true },
  { code: 'ZAR', symbol: 'R', name: 'South African Rand', paystackSupported: true },
  { code: 'KES', symbol: 'KSh', name: 'Kenyan Shilling', paystackSupported: true },

  // Other Major World Currencies
  { code: 'EUR', symbol: '€', name: 'Euro', paystackSupported: false },
  { code: 'GBP', symbol: '£', name: 'British Pound Sterling', paystackSupported: false },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc', paystackSupported: false },
  { code: 'NOK', symbol: 'kr', name: 'Norwegian Krone', paystackSupported: false },
  { code: 'SEK', symbol: 'kr', name: 'Swedish Krona', paystackSupported: false },
  { code: 'DKK', symbol: 'kr', name: 'Danish Krone', paystackSupported: false },
  { code: 'PLN', symbol: 'zł', name: 'Polish Złoty', paystackSupported: false },
  { code: 'CZK', symbol: 'Kč', name: 'Czech Koruna', paystackSupported: false },
  { code: 'HUF', symbol: 'Ft', name: 'Hungarian Forint', paystackSupported: false },
  { code: 'RON', symbol: 'lei', name: 'Romanian Leu', paystackSupported: false },
  { code: 'BGN', symbol: 'лв', name: 'Bulgarian Lev', paystackSupported: false },
  { code: 'RSD', symbol: 'дин', name: 'Serbian Dinar', paystackSupported: false },
  { code: 'HRK', symbol: 'kn', name: 'Croatian Kuna', paystackSupported: false },
  { code: 'UAH', symbol: '₴', name: 'Ukrainian Hryvnia', paystackSupported: false },
  { code: 'RUB', symbol: '₽', name: 'Russian Ruble', paystackSupported: false },
  { code: 'ISK', symbol: 'kr', name: 'Icelandic Krona', paystackSupported: false },
  { code: 'ALL', symbol: 'L', name: 'Albanian Lek', paystackSupported: false },
  { code: 'BAM', symbol: 'KM', name: 'Bosnian Convertible Mark', paystackSupported: false },

  // Africa (non-Paystack)
  { code: 'EGP', symbol: '£', name: 'Egyptian Pound', paystackSupported: false },
  { code: 'ETB', symbol: 'Br', name: 'Ethiopian Birr', paystackSupported: false },
  { code: 'TZS', symbol: 'TSh', name: 'Tanzanian Shilling', paystackSupported: false },
  { code: 'UGX', symbol: 'USh', name: 'Ugandan Shilling', paystackSupported: false },
  { code: 'MAD', symbol: 'د.م', name: 'Moroccan Dirham', paystackSupported: false },
  { code: 'DZD', symbol: 'دج', name: 'Algerian Dinar', paystackSupported: false },
  { code: 'TND', symbol: 'د.ت', name: 'Tunisian Dinar', paystackSupported: false },
  { code: 'LYD', symbol: 'ل.د', name: 'Libyan Dinar', paystackSupported: false },
  { code: 'RWF', symbol: 'FRw', name: 'Rwandan Franc', paystackSupported: false },
  { code: 'XOF', symbol: 'CFA', name: 'CFA Franc BCEAO', paystackSupported: false },
  { code: 'XAF', symbol: 'FCFA', name: 'CFA Franc BEAC', paystackSupported: false },
  { code: 'SOS', symbol: 'Sh', name: 'Somali Shilling', paystackSupported: false },
  { code: 'ZMW', symbol: 'ZK', name: 'Zambian Kwacha', paystackSupported: false },
  { code: 'MWK', symbol: 'MK', name: 'Malawian Kwacha', paystackSupported: false },
  { code: 'MZN', symbol: 'MT', name: 'Mozambican Metical', paystackSupported: false },
  { code: 'BWP', symbol: 'P', name: 'Botswana Pula', paystackSupported: false },
  { code: 'NAD', symbol: 'N$', name: 'Namibian Dollar', paystackSupported: false },
  { code: 'LSL', symbol: 'L', name: 'Lesotho Loti', paystackSupported: false },

  // Asia
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan Renminbi', paystackSupported: false },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen', paystackSupported: false },
  { code: 'KRW', symbol: '₩', name: 'South Korean Won', paystackSupported: false },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee', paystackSupported: false },
  { code: 'PKR', symbol: '₨', name: 'Pakistani Rupee', paystackSupported: false },
  { code: 'BDT', symbol: '৳', name: 'Bangladeshi Taka', paystackSupported: false },
  { code: 'IDR', symbol: 'Rp', name: 'Indonesian Rupiah', paystackSupported: false },
  { code: 'MYR', symbol: 'RM', name: 'Malaysian Ringgit', paystackSupported: false },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar', paystackSupported: false },
  { code: 'THB', symbol: '฿', name: 'Thai Baht', paystackSupported: false },
  { code: 'PHP', symbol: '₱', name: 'Philippine Peso', paystackSupported: false },
  { code: 'VND', symbol: '₫', name: 'Vietnamese Dong', paystackSupported: false },
  { code: 'SAR', symbol: '﷼', name: 'Saudi Riyal', paystackSupported: false },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham', paystackSupported: false },
  { code: 'QAR', symbol: '﷼', name: 'Qatari Riyal', paystackSupported: false },
  { code: 'KWD', symbol: 'د.ك', name: 'Kuwaiti Dinar', paystackSupported: false },
  { code: 'BHD', symbol: '.د.ب', name: 'Bahraini Dinar', paystackSupported: false },
  { code: 'OMR', symbol: '﷼', name: 'Omani Rial', paystackSupported: false },
  { code: 'TRY', symbol: '₺', name: 'Turkish Lira', paystackSupported: false },
  { code: 'ILS', symbol: '₪', name: 'Israeli Shekel', paystackSupported: false },
  { code: 'JOD', symbol: 'د.ا', name: 'Jordanian Dinar', paystackSupported: false },
  { code: 'LBP', symbol: 'ل.ل', name: 'Lebanese Pound', paystackSupported: false },
  { code: 'IRR', symbol: '﷼', name: 'Iranian Rial', paystackSupported: false },

  // North America
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar', paystackSupported: false },
  { code: 'MXN', symbol: '$', name: 'Mexican Peso', paystackSupported: false },

  // Central America & Caribbean
  { code: 'CRC', symbol: '₡', name: 'Costa Rican Colón', paystackSupported: false },
  { code: 'DOP', symbol: 'RD$', name: 'Dominican Peso', paystackSupported: false },
  { code: 'JMD', symbol: 'J$', name: 'Jamaican Dollar', paystackSupported: false },
  { code: 'HTG', symbol: 'G', name: 'Haitian Gourde', paystackSupported: false },
  { code: 'CUP', symbol: '₱', name: 'Cuban Peso', paystackSupported: false },
  { code: 'GTQ', symbol: 'Q', name: 'Guatemalan Quetzal', paystackSupported: false },
  { code: 'HNL', symbol: 'L', name: 'Honduran Lempira', paystackSupported: false },
  { code: 'NIO', symbol: 'C$', name: 'Nicaraguan Córdoba', paystackSupported: false },
  { code: 'PAB', symbol: 'B/.', name: 'Panamanian Balboa', paystackSupported: false },

  // South America
  { code: 'BRL', symbol: 'R$', name: 'Brazilian Real', paystackSupported: false },
  { code: 'ARS', symbol: '$', name: 'Argentine Peso', paystackSupported: false },
  { code: 'CLP', symbol: '$', name: 'Chilean Peso', paystackSupported: false },
  { code: 'COP', symbol: '$', name: 'Colombian Peso', paystackSupported: false },
  { code: 'PEN', symbol: 'S/', name: 'Peruvian Sol', paystackSupported: false },
  { code: 'VES', symbol: 'Bs.', name: 'Venezuelan Bolívar', paystackSupported: false },
  { code: 'PYG', symbol: '₲', name: 'Paraguayan Guaraní', paystackSupported: false },
  { code: 'UYU', symbol: '$U', name: 'Uruguayan Peso', paystackSupported: false },
  { code: 'BOB', symbol: 'Bs', name: 'Bolivian Boliviano', paystackSupported: false },

  // Oceania
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar', paystackSupported: false },
  { code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar', paystackSupported: false },
  { code: 'FJD', symbol: 'FJ$', name: 'Fijian Dollar', paystackSupported: false },
  { code: 'PGK', symbol: 'K', name: 'Papua New Guinea Kina', paystackSupported: false },
  { code: 'SBD', symbol: 'SI$', name: 'Solomon Islands Dollar', paystackSupported: false },
  { code: 'TOP', symbol: 'T$', name: 'Tongan Paʻanga', paystackSupported: false },
  { code: 'WST', symbol: 'WS$', name: 'Samoan Tala', paystackSupported: false },
  { code: 'VUV', symbol: 'VT', name: 'Vanuatu Vatu', paystackSupported: false }
]

export default function ProductsManagement({ website, websiteId, websiteCategory, onClose, section }) {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(false)
  const [showForm, setShowForm] = useState(false)
  const [editingProduct, setEditingProduct] = useState(null)
  const [imagePreview, setImagePreview] = useState(null)
  const imageInputRef = useRef(null)

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    price: '',
    currency: 'NGN',
    category: 'general',
    stock: '-1',
    sku: '',
    whatsappNumber: '',
    whatsappMessage: '',
    cartEnabled: true,
    image: null
  })

  const [submitting, setSubmitting] = useState(false)

  const storeId = websiteId || website?._id
  const storeCategory = websiteCategory || website?.category

  console.log('[ProductsManagement] Props received:', {
    websiteId,
    websiteCategory,
    website: website ? { _id: website._id, category: website.category, name: website.name } : null,
    section: section ? { _id: section._id, type: section.type, title: section.title } : null,
    resolvedStoreId: storeId,
    resolvedCategory: storeCategory
  })

  useEffect(() => {
    console.log('[ProductsManagement] Mount/Update:', {
      storeId,
      storeCategory,
      sectionType: section?.type,
      websiteId,
      website: website ? { _id: website._id, category: website.category } : null
    })
    
    // Load products if: ecommerce website OR product section
    const shouldLoad = (storeCategory === 'ecommerce' || section?.type === 'products') && storeId
    
    if (shouldLoad) {
      fetchProducts()
    }
  }, [storeId, storeCategory, section?.type])

  // Debug hook to track form state
  useEffect(() => {
    console.log('[ProductsManagement] State update:', {
      showForm,
      productsCount: products.length,
      loading,
      editingProduct: editingProduct ? { _id: editingProduct._id, name: editingProduct.name } : null
    })
  }, [showForm, products.length, loading, editingProduct])

  const fetchProducts = async () => {
    try {
      setLoading(true)
      console.log('[ProductsManagement] Fetching products for storeId:', storeId)
      
      if (!storeId) {
        console.log('[ProductsManagement] No storeId, setting empty products')
        setProducts([])
        return
      }
      
      const url = `/products/website/${storeId}`
      console.log('[ProductsManagement] Making request to:', url)
      
      const response = await axios.get(url)
      console.log('[ProductsManagement] Response:', {
        success: response.data.success,
        productsCount: response.data.products?.length,
        productsWithImages: response.data.products?.filter(p => p.image?.url).length,
        firstProductImage: response.data.products?.[0]?.image
      })
      
      const productsList = response.data.products || response.data || []
      console.log('[ProductsManagement] Setting products:', {
        count: productsList.length,
        details: productsList.map(p => ({
          _id: p._id,
          name: p.name,
          hasImage: !!p.image,
          imageUrl: p.image?.url
        }))
      })
      
      setProducts(productsList)
    } catch (error) {
      console.error('[ProductsManagement] Error fetching products:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        url: error.config?.url
      })
      
      // Don't show toast error if storeId is missing (expected behavior)
      if (storeId) {
        toast.error('Failed to load products: ' + (error.response?.data?.message || error.message))
      }
    } finally {
      setLoading(false)
    }
  }

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      setFormData({ ...formData, image: file })
      const reader = new FileReader()
      reader.onloadend = () => {
        setImagePreview(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = async (e) => {
    if (e?.preventDefault) e.preventDefault()
    if (e?.stopPropagation) e.stopPropagation() // CRITICAL: Stop bubbling to parent form

    // Validation
    if (!formData.name || !formData.name.trim()) {
      toast.error('Product name is required')
      return
    }

    if (!formData.price || parseFloat(formData.price) <= 0) {
      toast.error('Product price must be greater than 0')
      return
    }

    if (!storeId) {
      toast.error('Website information is missing')
      console.error('[ProductsManagement] Cannot submit - no storeId')
      return
    }

    try {
      setSubmitting(true)
      const data = new FormData()
      data.append('name', formData.name.trim())
      data.append('description', formData.description || '')
      data.append('price', parseFloat(formData.price))
      data.append('currency', formData.currency || 'NGN')
      data.append('category', formData.category || 'general')
      data.append('stock', parseInt(formData.stock) || -1)
      data.append('sku', (formData.sku || '').toUpperCase())
      data.append('whatsappNumber', formData.whatsappNumber || '')
      data.append('whatsappMessage', formData.whatsappMessage || '')
      data.append('cartEnabled', formData.cartEnabled)
      
      // Only append image if a new file was selected
      if (formData.image instanceof File) {
        console.log('[ProductsManagement] Image file detected:', {
          name: formData.image.name,
          size: formData.image.size,
          type: formData.image.type
        })
        data.append('image', formData.image)
      }

      console.log('[ProductsManagement] Submitting product:', {
        isEditing: !!editingProduct,
        storeId,
        productId: editingProduct?._id,
        name: formData.name,
        price: formData.price
      })

      let response
      if (editingProduct) {
        console.log('[ProductsManagement] Sending PUT request to /products/' + editingProduct._id)
        response = await axios.put(`/products/${editingProduct._id}`, data)
        console.log('[ProductsManagement] Product updated successfully:', response.data)
        toast.success('Product updated successfully')

        // Update product in local list optimistically
        if (response.data.product) {
          setProducts(prev => prev.map(p => (p._id === response.data.product._id ? response.data.product : p)))
        }

        // After editing, close form and refresh list from backend
        resetForm()
        await fetchProducts()
      } else {
        const endpoint = `/products/website/${storeId}`
        console.log('[ProductsManagement] Sending POST request to', endpoint)
        response = await axios.post(endpoint, data)
        console.log('[ProductsManagement] Product created successfully:', response.data)

        // OPTIMISTIC UPDATE: Add product to list immediately
        if (response.data.product) {
          console.log('[ProductsManagement] Optimistically adding product to list:', {
            productId: response.data.product._id,
            name: response.data.product.name,
            hasImage: !!response.data.product.image,
            imageUrl: response.data.product.image?.url,
            imageData: response.data.product.image
          })
          setProducts(prev => [response.data.product, ...prev])
        } else {
          console.warn('[ProductsManagement] Response missing product data, attempting to fetch...')
          // If response doesn't include product, fetch the updated list
          await fetchProducts()
        }

        toast.success('Product created successfully!')

        // OPTIMISTIC: add and show newly created product, then close form to show products list
        if (response.data.product) {
          setProducts(prev => [response.data.product, ...prev])
        }

        // Clear fields
        setFormData({
          name: '',
          description: '',
          price: '',
          currency: 'NGN',
          category: 'general',
          stock: '-1',
          sku: '',
          whatsappNumber: '',
          whatsappMessage: '',
          cartEnabled: true,
          image: null
        })
        setImagePreview(null)
        setEditingProduct(null)

        // Ensure latest from backend and then show products list
        await fetchProducts()
        setShowForm(false)
      }

      // Verify response contains product data
      if (!response.data.product) {
        console.warn('[ProductsManagement] Response missing product data:', response.data)
      }
      
    } catch (error) {
      const errorMsg = error.response?.data?.message || error.message || 'Failed to save product'
      console.error('[ProductsManagement] Error saving product:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        responseData: error.response?.data,
        url: error.config?.url,
        fullError: error
      })
      toast.error(errorMsg)
    } finally {
      setSubmitting(false)
    }
  }

  const handleEdit = (product) => {
    setEditingProduct(product)
    setFormData({
      name: product.name,
      description: product.description,
      price: product.price,
      currency: product.currency,
      category: product.category,
      stock: product.stock,
      sku: product.sku || '',
      whatsappNumber: product.whatsappNumber || '',
      whatsappMessage: product.whatsappMessage || '',
      cartEnabled: product.cartEnabled !== undefined ? product.cartEnabled : true,
      image: null
    })
    if (product.image?.url) {
      setImagePreview(product.image.url)
    }
    setShowForm(true)
  }

  const handleDelete = async (productId) => {
    if (!window.confirm('Are you sure you want to delete this product?')) return

    try {
      console.log('[ProductsManagement] Deleting product:', productId)
      
      await axios.delete(`/products/${productId}`)
      
      console.log('[ProductsManagement] Product deleted, removing from list')
      
      // Optimistically remove from list
      setProducts(prev => prev.filter(p => p._id !== productId))
      
      toast.success('Product deleted successfully')
      
      // Refresh list in background to verify
      await fetchProducts()
      
      console.log('[ProductsManagement] Products list refreshed after deletion')
    } catch (error) {
      console.error('[ProductsManagement] Error deleting product:', error)
      toast.error(error.response?.data?.message || 'Failed to delete product')
    }
  }

  const resetForm = () => {
    console.log('[ProductsManagement] Resetting form to show products list')
    setShowForm(false)
    setEditingProduct(null)
    setImagePreview(null)
    setFormData({
      name: '',
      description: '',
      price: '',
      currency: 'NGN',
      category: 'general',
      stock: '-1',
      sku: '',
      whatsappNumber: '',
      whatsappMessage: '',
      cartEnabled: true,
      image: null
    })
    if (imageInputRef.current) {
      imageInputRef.current.value = ''
    }
    console.log('[ProductsManagement] Form reset - showForm is now false')
  }

  // Show nothing if not ecommerce and not product section
  if (storeCategory !== 'ecommerce' && section?.type !== 'products') {
    console.log('[ProductsManagement] Returning null - wrong category/section:', {
      storeCategory,
      sectionType: section?.type
    })
    return null
  }

  // Show error if no website ID
  if (!storeId) {
    console.log('[ProductsManagement] No storeId, showing error')
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <p className="text-sm text-yellow-800 font-medium">⚠️ Website information not available</p>
        <p className="text-xs text-yellow-700 mt-1">Please reload the page or contact support if the issue persists.</p>
      </div>
    )
  }

  console.log('[ProductsManagement] Rendering - all checks passed', {
    storeId,
    storeCategory,
    sectionType: section?.type,
    loading,
    productsCount: products.length
  })

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-900">
          Products {products.length > 0 && !showForm && <span className="text-sm font-normal text-gray-600">({products.length})</span>}
        </h3>
        {!showForm && (
          <button
            onClick={(e) => {
              e.stopPropagation()
              console.log('[ProductsManagement] Opening form - setting showForm to true')
              setShowForm(true)
            }}
            className="flex items-center gap-2 px-3 py-1.5 bg-primary-600 text-white hover:bg-primary-700 rounded font-medium text-sm transition-colors"
          >
            <FiPlus className="w-4 h-4" /> Add Product
          </button>
        )}
      </div>

      {loading && !showForm && (
        <div className="flex justify-center py-8">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary-600"></div>
        </div>
      )}

      {!loading && products.length === 0 && !showForm && (
        <div className="text-center py-6 bg-gray-50 rounded-lg">
          <p className="text-gray-600 text-sm">No products yet. Create your first product!</p>
        </div>
      )}

      {!loading && products.length > 0 && !showForm && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-100 border-b border-gray-200">
                <tr>
                  <th className="px-3 py-2 text-left font-semibold text-gray-700">Image</th>
                  <th className="px-3 py-2 text-left font-semibold text-gray-700">Name</th>
                  <th className="px-3 py-2 text-left font-semibold text-gray-700">Description</th>
                  <th className="px-3 py-2 text-left font-semibold text-gray-700">Price</th>
                  <th className="px-3 py-2 text-left font-semibold text-gray-700">Stock</th>
                  <th className="px-3 py-2 text-left font-semibold text-gray-700">Cart</th>
                  <th className="px-3 py-2 text-right font-semibold text-gray-700">Actions</th>
                </tr>
            </thead>
            <tbody>
              {products.map(product => (
                <tr key={product._id} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="px-3 py-2">
                      {product.image?.url ? (
                        <img src={product.image.url} alt={product.name} className="w-12 h-12 object-cover rounded" />
                      ) : (
                        <div className="w-12 h-12 bg-gray-100 flex items-center justify-center text-xs text-gray-400 rounded">No Image</div>
                      )}
                    </td>
                    <td className="px-3 py-2 text-gray-900">{product.name}</td>
                    <td className="px-3 py-2 text-gray-700 text-sm truncate max-w-xs">{product.description || '-'}</td>
                    <td className="px-3 py-2 text-gray-900">{product.currency} {product.price}</td>
                    <td className="px-3 py-2 text-gray-900">{product.stock === -1 ? 'Unlimited' : product.stock}</td>
                    <td className="px-3 py-2 text-gray-900">
                      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                        product.cartEnabled !== false ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      }`}>
                        {product.cartEnabled !== false ? 'Enabled' : 'Disabled'}
                      </span>
                    </td>
                  <td className="px-3 py-2 text-right space-x-2">
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation()
                        handleEdit(product)
                      }}
                      className="text-primary-600 hover:text-primary-700 transition-colors"
                      title="Edit"
                    >
                      <FiEdit2 className="w-4 h-4" />
                    </button>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation()
                        handleDelete(product._id)
                      }}
                      className="text-red-600 hover:text-red-700 transition-colors"
                      title="Delete"
                    >
                      <FiTrash2 className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Product Form */}
      {showForm && (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-4">
          <div className="flex justify-between items-center">
            <h4 className="font-semibold text-gray-900 text-sm">
              {editingProduct ? 'Edit Product' : 'Add New Product'}
            </h4>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation()
                resetForm()
              }}
              className="text-gray-500 hover:text-gray-700"
            >
              <FiX className="w-5 h-5" />
            </button>
          </div>

          <div className="space-y-3">
            {/* Image Upload */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-2">Product Image</label>
              <div className="flex gap-3">
                {imagePreview && (
                  <img src={imagePreview} alt="Preview" className="w-16 h-16 object-cover rounded" />
                )}
                <label className="flex items-center justify-center w-20 h-20 border-2 border-dashed border-gray-300 rounded cursor-pointer hover:border-primary-400 transition-colors">
                  <div className="text-center">
                    <FiUpload className="w-5 h-5 text-gray-400 mx-auto" />
                    <p className="text-xs text-gray-600 mt-1">Upload</p>
                  </div>
                  <input
                    ref={imageInputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="hidden"
                  />
                </label>
              </div>
            </div>

            {/* Product Name */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Product Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="e.g., Premium Headphones"
                className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>

            {/* Description */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Description</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows="3"
                placeholder="Describe your product..."
                className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 resize-none"
              />
            </div>

            {/* Price & Currency */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Price *</label>
                <input
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleInputChange}
                  step="0.01"
                  min="0"
                  placeholder="0.00"
                  className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Currency</label>
                <select
                  name="currency"
                  value={formData.currency}
                  onChange={handleInputChange}
                  className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                >
                  {CURRENCIES.map(currency => (
                    <option key={currency.code} value={currency.code}>
                      {currency.code} ({currency.symbol}) - {currency.name}{currency.paystackSupported ? ' *' : ''}
                    </option>
                  ))}
                </select>
                <p className="text-xs text-gray-500 mt-1">* Paystack supported currencies. Unsupported currencies will default to NGN during checkout.</p>
              </div>
            </div>

            {/* Category & Stock */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Category</label>
                <input
                  type="text"
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                  placeholder="e.g., Electronics"
                  className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Stock (-1 = Unlimited)</label>
                <input
                  type="number"
                  name="stock"
                  value={formData.stock}
                  onChange={handleInputChange}
                  min="-1"
                  placeholder="-1"
                  className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
              </div>
            </div>

            {/* SKU */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">SKU (Optional)</label>
              <input
                type="text"
                name="sku"
                value={formData.sku}
                onChange={handleInputChange}
                placeholder="e.g., PROD-001"
                className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>

            {/* WhatsApp Contact */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">WhatsApp Number (Optional)</label>
              <input
                type="text"
                name="whatsappNumber"
                value={formData.whatsappNumber}
                onChange={handleInputChange}
                placeholder="e.g., +1234567890"
                className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
              <p className="text-xs text-gray-500 mt-1">Include country code (e.g., +1 for US, +234 for Nigeria)</p>
            </div>

            {/* WhatsApp Message */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">WhatsApp Message Template (Optional)</label>
              <textarea
                name="whatsappMessage"
                value={formData.whatsappMessage}
                onChange={handleInputChange}
                rows="2"
                placeholder="Hi! I'm interested in your product. Please provide more details."
                className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 resize-none"
              />
              <p className="text-xs text-gray-500 mt-1">This message will be pre-filled when customers click the WhatsApp button</p>
            </div>

            {/* Cart Enabled Toggle */}
            <div>
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  name="cartEnabled"
                  checked={formData.cartEnabled}
                  onChange={(e) => setFormData({ ...formData, cartEnabled: e.target.checked })}
                  className="w-4 h-4 text-primary-600 bg-gray-100 border-gray-300 rounded focus:ring-primary-500 focus:ring-2"
                />
                <span className="text-xs font-medium text-gray-700">Enable Cart for this Product</span>
              </label>
              <p className="text-xs text-gray-500 mt-1">
                When enabled, customers can add this product to their cart and purchase it. When disabled, the cart button won't appear on the public website.
              </p>
            </div>

            {/* Buttons */}
            <div className="flex gap-2 pt-2">
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation()
                  handleSubmit(e)
                }}
                disabled={submitting}
                className={`flex-1 px-3 py-1.5 rounded font-medium text-sm transition-colors ${submitting ? 'bg-primary-400 text-white cursor-not-allowed' : 'bg-primary-600 text-white hover:bg-primary-700'}`}
              >
                {submitting ? (
                  <span className="flex items-center justify-center gap-2">
                    <FiLoader className="w-4 h-4 animate-spin" />
                    {editingProduct ? 'Updating...' : 'Creating...'}
                  </span>
                ) : (
                  (editingProduct ? 'Update' : 'Create')
                )}
              </button>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation()
                  resetForm()
                }}
                className="flex-1 px-3 py-1.5 border border-gray-300 text-gray-700 hover:bg-gray-100 rounded font-medium text-sm transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
